// extracted by mini-css-extract-plugin
export default {"pageRoot":"ComingSoonPage_pageRoot__orQbj","cover":"ComingSoonPage_cover__D53wS","door":"ComingSoonPage_door__YXwbA","wrapper":"ComingSoonPage_wrapper__4fwI4"};